import * as tslib_1 from "tslib";
import { getStore, collectedOptions } from 'owa-options-store';
import { observer } from 'mobx-react';
import { ActionButton, CommandButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { selectCategory, hideFullOptions } from 'owa-options-orchestration';
import FullOptionSearch from './FullOptionSearch';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
var styles = require('./OptionsFull.scss');
var className = require('classnames/bind').bind(styles);
var CategoryEntry = observer(function (props) {
    var buttonStyles = {
        root: className(styles.category, {
            selectedCategory: getStore().currentCategoryKey === props.category.key,
        }),
        flexContainer: styles.flexContainer,
        label: styles.categoryLabel,
    };
    var iconProps = {
        iconName: props.category.icon,
        styles: {
            root: styles.categoryIcon,
        },
    };
    return (React.createElement(ActionButton, { styles: buttonStyles, key: props.category.key, onClick: function () { return selectCategory(props.category); }, iconProps: iconProps, text: strings[props.category.titleStringKey] }));
});
var CategoriesColumn = /** @class */ (function (_super) {
    tslib_1.__extends(CategoriesColumn, _super);
    function CategoriesColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoriesColumn.prototype.render = function () {
        return (React.createElement("div", { className: styles.categoriesColumn },
            React.createElement("span", { className: styles.title, role: "heading", "aria-level": 2 }, strings.options_title),
            React.createElement(FullOptionSearch, null),
            React.createElement(FocusZone, { direction: FocusZoneDirection.vertical }, collectedOptions().map(function (category) { return (React.createElement(CategoryEntry, { category: category, key: category.key })); })),
            React.createElement(CommandButton, { className: styles.viewQuickSettings, onClick: this.goToQuickOptions, iconProps: {
                    iconName: "ChevronLeft" /* ChevronLeft */,
                    styles: {
                        root: className(styles.icon, 'flipForRtl'),
                    },
                }, text: strings.optionsFull_goToQuickOptions })));
    };
    CategoriesColumn.prototype.goToQuickOptions = function () {
        hideFullOptions(true /* showQuickOptions */);
    };
    CategoriesColumn = tslib_1.__decorate([
        observer
    ], CategoriesColumn);
    return CategoriesColumn;
}(React.Component));
export default CategoriesColumn;
//# sourceMappingURL=CategoriesColumn.js.map